import io, { Socket } from "socket.io-client";
import API_CONSTANTS from "../constants/api";
import type { OrderEvent } from "../../types/orderEvent";
import { type ProgressWSInterface, type ProgressWSOptions } from "./progressWSInterface";

export default class ProgressWS implements ProgressWSInterface {
  public onStatusUpdate: ((event: OrderEvent) => void);
  public jwt: string;
  public internalProcessKey: string | undefined;
  public socket: Socket | undefined;
  protected connected = false;
  
  constructor({ onStatusUpdate, jwt, internalProcessKey }: ProgressWSOptions) {
    this.jwt = jwt;
    this.internalProcessKey = internalProcessKey;
    this.onStatusUpdate = onStatusUpdate;
  }

  connect() {
    this.socket = this.socket ?? io(API_CONSTANTS.wsBaseUrl, { path: "/foojiSocket" });

    this.socket.on("connect", () => {
      console.log("connected to websocket!");
      this.connected = true;
      this.socket?.emit("authenticate",
        {
          jwt: this.jwt,
          internal_process_key: this.internalProcessKey
        });
    });
    
    this.socket.on("authenticated", () => {
      console.log("authenticated!");
      this.socket?.emit("get-latest");
    });
    
    this.socket.on("authentication-error", () => {
      console.log("authentication error :(");
    });
    
    this.socket.on("courier-update", (event: OrderEvent) => {
      this.onStatusUpdate?.(event);
    });

    this.socket.on("status-update", (event: OrderEvent) => {
      console.log("got a status update event ...", event);
      this.onStatusUpdate?.(event);
    });
  }

  disconnect() {
    console.log("disconnecting from websocket ...");
    if (this.socket && this.connected) {
      this.socket.disconnect();
      this.socket = undefined;
      this.connected = false;
    }
  }
}
